document.addEventListener("DOMContentLoaded", () => {
  const root =
    document.querySelector(".cm-global-root[data-cm-root]") ||
    document.querySelector(".cyber-hero[data-cm-root]");

  if (!root) return;

  const toggles = root.querySelectorAll("[data-cm-toggle]");
  const closeBtn = root.querySelector("[data-cm-close]");
  const drawer = root.querySelector(".cm-panel__drawer");
  const ribbon = root.querySelector(".cm-ribbon-bar");

  // YOUR REAL OVERLAY (global)
  const globalOverlay = document.querySelector(".cm-overlay");

  /* ==============================
     OVERLAY HELPERS
     ============================== */
  const activateOverlay = () => {
    globalOverlay?.classList.add("active");
  };

  const deactivateOverlay = () => {
    globalOverlay?.classList.remove("active");
  };

  /* ==============================
     OPEN / CLOSE PANEL
     ============================== */
  const open = () => {
    root.classList.add("cyber-hero--open");
    document.body.classList.add("cm-open");
    activateOverlay();
  };

  const close = () => {
    root.classList.remove("cyber-hero--open");
    document.body.classList.remove("cm-open");
    deactivateOverlay();
  };

  /* ==============================
     TOGGLE CLICK (ribbon + button)
     ============================== */
  toggles.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.stopPropagation();
      root.classList.contains("cyber-hero--open") ? close() : open();
    });
  });

  /* Close button */
  closeBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    close();
  });

  /* Click on overlay closes */
  globalOverlay?.addEventListener("click", close);

  /* ==============================
     OUTSIDE CLICK CLOSE
     ============================== */
  document.addEventListener("click", (e) => {
    if (!root.classList.contains("cyber-hero--open")) return;

    const insidePanel = drawer.contains(e.target);
    const clickedToggle = [...toggles].some((btn) => btn.contains(e.target));
    const clickedRibbon = ribbon?.contains(e.target);

    if (!insidePanel && !clickedToggle && !clickedRibbon) {
      close();
    }
  });

  /* ESC key closes */
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
});


/* =============================
   COPY TO CLIPBOARD (DESKTOP)
   ============================= */
document.addEventListener("DOMContentLoaded", () => {
  const tiers = document.querySelectorAll(".cm-tier");

  tiers.forEach((tier) => {
    tier.addEventListener("click", () => {
      const codeLabel = tier.querySelector(".cm-tier__code-label");
      if (!codeLabel) return;

      const rawText = codeLabel.textContent.trim(); 
      const value = rawText.split(" ").pop(); // CM10 only

      copyToClipboard(value);
    });
  });
});
